import { gql } from '@apollo/client';

export const CREATE_METRIC_RECORD = gql`
  mutation CreateMetricRecord($input: CreateMetricRecordRequest!) {
    createMetricRecord(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const CREATE_BULK_METRIC_RECORD = gql`
  mutation CreateBulkMetricRecord($input: CreateBulkMetricRecordRequest!) {
    createBulkMetricRecord(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result
    }
  }
`;

export const UPDATE_METRIC_RECORD = gql`
  mutation UpdateMetricRecord($input: UpdateMetricRecordRequest!) {
    updateMetricRecord(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const SOFT_DELETE_METRIC_RECORD = gql`
  mutation SoftDeleteMetricRecord($input: SoftDeleteMetricRecordRequest!) {
    softDeleteMetricRecord(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const HARD_DELETE_BULK_METRIC_RECORD = gql`
  mutation HardDeleteBulkMetricRecord($input: HardDeleteBulkMetricRecordRequest!) {
    hardDeleteBulkMetricRecord(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result
    }
  }
`;
